import { AuditServiceRank } from '../models';
import * as St from '../styles';
import { formatNumber, formatPercent } from '../utils';
import CardStatus, { CardStatusProps } from './CardStatus';

const ApiServices: React.FC<
  { services?: AuditServiceRank[] } & CardStatusProps
> = ({ services = [], loading, error }) => {
  return (
    <St.Card padding={28}>
      <St.CardHeader>
        <St.CardTitle>
          <h3>Serviços de API</h3>
          <span>Participação nas chamadas de API filtradas</span>
        </St.CardTitle>
        <St.Badge>TOP 30</St.Badge>
      </St.CardHeader>
      <CardStatus loading={loading} error={error} height={120}>
        {services.length === 0 && (
          <St.CardStatus height={80}>
            Nenhuma chamada de API no período.
          </St.CardStatus>
        )}
        <St.ServicesGrid>
          {services.slice(0, 30).map((service, index) => (
            <St.ServiceItem key={service.servico}>
              <span className="rank">{String(index + 1).padStart(2, '0')}</span>
              <span className="name">{service.servico}</span>
              <span className="total">{formatNumber(service.chamadas)}</span>
              <span className="percent">
                {formatPercent(service.percentual)}
              </span>
              <St.Progress value={service.percentual} />
            </St.ServiceItem>
          ))}
        </St.ServicesGrid>
      </CardStatus>
    </St.Card>
  );
};

export default ApiServices;
